import React from 'react';
import { withTheme } from 'styled-components';
import { XCloseIcon, FloorsIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';

const Disclaimer = withTheme(({ onCloseDisclaimer, ...props }) => {
  const theme = props.theme;
  return (
    <Box
      bg="mapCard.disclaimer.bg"
      border="2px solid #fff"
      borderRadius="5px"
      horizontal
      py="3px"
      pl="12px"
      pr="4px"
      width="300px"
      align="center"
      justify="space-between"
    >
      <Box horizontal py="9px">
        <FloorsIcon color={theme.colors.mapCard.disclaimer.floorsIcon} />
        <Box px="6px">
          <Text
            color="mapCard.disclaimer.primaryText"
            fontWeight="bold"
            size="xsmall"
            textTransform="uppercase"
          >
            Markers are not displayed by altitude.
          </Text>
          <Text color="mapCard.disclaimer.secondaryText" size="xsmall">
            Marker location may display on every floor
          </Text>
        </Box>
      </Box>
      <Box alignSelf="flex-start" cursor="pointer">
        <XCloseIcon
          color={theme.colors.mapCard.disclaimer.floorsIcon}
          onClick={onCloseDisclaimer}
        />
      </Box>
    </Box>
  );
});

export default Disclaimer;
